import Hero from "../../components/Hero";
import Features from "../../components/Features";
import Sandbox from "../../components/Sandbox";
import FeaturedCourses from "../../components/FeaturedCourses";
import Community from "../../components/Community";

const HomePage = () => {
  return (
    <div>
      <Hero />
      <Features />
      <Sandbox />
      <FeaturedCourses />
      <Community />
    </div>
  );
};

export default HomePage;
